import '../styles/register.scss';
import { TextField, Alert, Select, FormControl, InputLabel, MenuItem } from "@mui/material";
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


export default function PreCheck() {
  const url = "https://dev.pmwwebdesign.com";
  // const url = 'http://localhost:3999';
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [business, setBusiness] = useState('');
  const [turnOver, setTurnOver] = useState('');
  // !ALERTS
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [severity, setSeverity] = useState("");



  const submit = () => {
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const phoneRegex = /^[0-9]*$/
    if (name === "" || email === "" || lastName === "" || phone === "" || business === "" || turnOver === "") {
      setMessage("All fields are required");
      setSeverity("warning");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    } else if (!email.match(regex)) {
      setMessage("Email is the wrong format");
      setSeverity("warning");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    } else if (!phone.match(phoneRegex)) {
      setMessage("Phone should be only numbers");
      setSeverity("warning");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    } else {
      const data = {
        firstName: name,
        lastName: lastName,
        email: email,
        phone: phone,
        businessName: business,
        turnOver: turnOver
      }
      axios.post(`${url}/mastermind/pre-check`, data)
      .then((res) => {
        console.log(res.data)
        navigate('/');
      }).catch((err) => {
        setMessage("Something went wrong, please try again");
        setSeverity("error");
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
      })
    }
  }

  const handleChange = (event) => {
    setTurnOver(event.target.value);
  };

  return (
    <main className="register">
      <h2>please provide your details to find out more</h2>
      <section className="form">
        <section className="form__row">
          <TextField id="outlined-basic" label="First Name" variant="outlined" className='text--field' onChange={(e) => setName(e.target.value)} />
          <TextField id="outlined-basic" label="Last Name" variant="outlined" className='text--field' onChange={(e) => setLastName(e.target.value)} />
        </section>
        <section className="form__row">
          <TextField id="outlined-basic" label="Email" variant="outlined" className='text--field' onChange={(e) => setEmail(e.target.value)} />
          <TextField id="outlined-basic" label="Phone Number" variant="outlined" className='text--field' onChange={(e) => setPhone(e.target.value)} />
        </section>
        <section className="form__row">
          <TextField id="outlined-basic" label="Business Name" variant="outlined" className='text--field' onChange={(e) => setBusiness(e.target.value)} />
          <FormControl className='text--field'>
            <InputLabel id="demo-simple-select-label">Business Turnover</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={turnOver}
              label="Age"
              onChange={(e) => handleChange(e)}
              className='text--field'
            >
              <MenuItem value={'50k - 250k'}>50k - 250k</MenuItem>
              <MenuItem value={'250k - 500k'}>250k - 500k</MenuItem>
              <MenuItem value={'500k - 1M'}>500k - 1M</MenuItem>
              <MenuItem value={'1M - 5M'}>1M - 5M</MenuItem>
              <MenuItem value={'5M+'}>5M +</MenuItem>
            </Select>
          </FormControl>
        </section>
        {showAlert ? <Alert severity={severity}>{message}</Alert> : <buttom className="app__button" onClick={submit}>Submit</buttom>}
      </section>
    </main>
  )
}